export default "__VITE_ASSET__17e50185__"